import { isDetachedSpace, type PaletteKind, type SpaceKind } from './contextModel.js'

export type SurfacePolicyContext = {
  space: SpaceKind
  palette: PaletteKind
}

export type SurfacePolicy = {
  visible: boolean
  disabled: boolean
  runnableWithFeedback: boolean
}

const VISIBLE_ENABLED: SurfacePolicy = {
  visible: true,
  disabled: false,
  runnableWithFeedback: false
}

const HIDDEN: SurfacePolicy = {
  visible: false,
  disabled: false,
  runnableWithFeedback: false
}

const isUserAction = (id: string): boolean => id.startsWith('user-')
const isAccountAction = (id: string): boolean => id.startsWith('account-')
const isSpaceAction = (id: string): boolean => id.startsWith('space-')
const isPausedLifecycleAction = (id: string): boolean =>
  id === 'reactivate sync' || id === 'export sync shelf' || id === 'log out'

// Go/pill surface command policy. Descriptor/capability visibility stays authoritative and this
// matrix acts as a deterministic surface filter.
export function selectPillCommandPolicy(commandId: string, context: SurfacePolicyContext): SurfacePolicy {
  if (context.palette !== 'go') return HIDDEN
  if (isDetachedSpace(context.space)) return HIDDEN
  if (isUserAction(commandId)) return HIDDEN
  if (isAccountAction(commandId)) return HIDDEN
  if (isSpaceAction(commandId)) return HIDDEN
  if (isPausedLifecycleAction(commandId)) return HIDDEN
  return VISIBLE_ENABLED
}
